import React from 'react';
import { Tooltip, theme } from 'antd';
import { useAppearance } from '../../../components/contexts/AppearanceContext';

export function MakeLogoTile({ src, name, height = 24, width = height * 1.5, tone, onError, title, style }) {
  const { token } = theme.useToken();
  const { isDark } = useAppearance();
  const needsBacking = isDark && tone === 'dark';
  const background = needsBacking ? token.colorFillSecondary : undefined;
  return <Tooltip title={title || name}><span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, width, height, borderRadius: 3, background, padding: needsBacking ? 2 : 0, ...style }}>
    <img src={src} alt={name || 'Make logo'} loading="lazy" decoding="async" onError={onError} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
  </span></Tooltip>;
}
